import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withState, lifecycle, withHandlers } from 'react-recompose';
// components
import { openLoader, closeLoader } from '../components/loader/actions';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
/////////////////////////////////////////////////

const withAsyncDocumentTemplates = compose(
  connect(null, { openLoader, closeLoader }),
  withState('defaultTemplateGuid', 'setDefaultTemplateGuid', null),
  withState('asyncDocumentTemplates', 'setAsyncDocumentTemplates', null),
  withHandlers({
    getDefaultTemplate: (props) => async () => {
      const { branchGuid, openLoader, closeLoader, setDefaultTemplateGuid } = props;

      openLoader();

      const options = {
        data: {
          [GC.FIELD_BRANCH_GUID]: branchGuid,
          configNames: [GC.INVOICE_CLO_CUSTOMER_INVOICE_PRINT_DEFAULT_TEMPLATE],
        },
      };

      const res = await sendRequest('post', endpointsMap.branchConfigsByNames, options);


      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        const mappedConfigs = G.mapConfigValuesByName(data);

        const configValue = G.getConfigValueFromStore(
          GC.INVOICE_CLO_CUSTOMER_INVOICE_PRINT_DEFAULT_TEMPLATE,
          mappedConfigs,
        );

        setDefaultTemplateGuid(configValue);
      } else {
        G.handleFailResponseSimple(res);
      }

      closeLoader();
    },
    getDocumentTemplates: (props) => async () => {
      const { branchGuid, openLoader, closeLoader, setAsyncDocumentTemplates } = props;

      openLoader();

      const currentBranchGuid = G.getCurrentBranchGuid();

      const branchGuidToUse = R.or(branchGuid, currentBranchGuid);

      const options = {
        params: { [GC.FIELD_BRANCH_GUID]: branchGuidToUse },
      };

      const res = await sendRequest('get', endpointsMap.availableDocumentTemplates, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        setAsyncDocumentTemplates(R.groupBy(R.prop(GC.FIELD_PRINTABLE_SECTION), data));
      } else {
        G.handleFailResponseSimple(res);
      }

      closeLoader();
    },
    getDocumentTemplatesWithParams: (props) => async () => {
      const {
        branchGuid,
        dataSource,
        openLoader,
        closeLoader,
        divisionGuid,
        orderTypeGuids,
        printableSection,
        customerEnterpriseGuids,
        setAsyncDocumentTemplates,
      } = props;

      openLoader();

      const currentBranchGuid = G.getCurrentBranchGuid();

      const branchGuidToUse = R.or(branchGuid, currentBranchGuid);

      const options = {
        data: {
          [GC.FIELD_DATA_SOURCE]: dataSource,
          [GC.FIELD_DIVISION_GUID]: divisionGuid,
          [GC.FIELD_BRANCH_GUID]: branchGuidToUse,
          [GC.FIELD_ORDER_TYPE_GUIDS]: orderTypeGuids,
          [GC.FIELD_PRINTABLE_SECTION]: printableSection,
          [GC.FIELD_CUSTOMER_ENTERPRISE_GUIDS]: customerEnterpriseGuids,
        },
      };

      const res = await sendRequest('post', endpointsMap.documentTemplatesEndpoint, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        setAsyncDocumentTemplates(R.groupBy(R.prop(GC.FIELD_PRINTABLE_SECTION), data));
      } else {
        G.handleFailResponseSimple(res);
      }

      closeLoader();
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        withParams,
        getDefaultTemplate,
        withDefaultTemplate,
        getDocumentTemplates,
        getDocumentTemplatesWithParams,
      } = this.props;

      if (G.isTrue(withDefaultTemplate)) return getDefaultTemplate();

      if (G.isTrue(withParams)) return getDocumentTemplatesWithParams();

      getDocumentTemplates();
    },
  }),
);

const withAsyncDocumentTemplatesByTelGuid = compose(
  withState('asyncDocumentTemplates', 'setAsyncDocumentTemplates', R.path(['telDocumentTemplates'])),
  withHandlers({
    getDocumentTemplates: (props) => async () => {
      const { telGuid, openLoader, closeLoader, setAsyncDocumentTemplates, setDocumentTemplatesToStore } = props;

      openLoader();

      const options = {
        params: { telGuid },
      };

      if (G.isNilOrEmpty(telGuid)) return;

      const res = await sendRequest('get', endpointsMap.getDocumentTemplatesByTelGuid, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        const gropedByPrintableSectionDocumentTemplates = R.groupBy(R.prop(GC.FIELD_PRINTABLE_SECTION), data);

        setAsyncDocumentTemplates(gropedByPrintableSectionDocumentTemplates);

        G.callFunctionWithArgs(setDocumentTemplatesToStore, gropedByPrintableSectionDocumentTemplates);
      } else {
        G.handleFailResponseSimple(res);
      }

      closeLoader();
    },
  }),
  lifecycle({
    componentDidMount() {
      const { telDocumentTemplates, getDocumentTemplates } = this.props;

      if (G.isNilOrEmpty(telDocumentTemplates)) getDocumentTemplates();
    },
  }),
);

export {
  withAsyncDocumentTemplates,
  withAsyncDocumentTemplatesByTelGuid,
};
